// extracted by mini-css-extract-plugin
export default {"text":"PromoModal_text__cR7IW","button":"PromoModal_button__qUFWl"};